/* eslint-disable react/prop-types */
import React from 'react';

import PropTypes from 'prop-types';
import {batch, connect} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {consoleDebug} from '@/libs/consoleHelper';

import {STATUS_SEQUENCE_DESINGER} from '../constant/sequenceContentConstants';

@connect((store) => ({
  isManualProfileRunning: store.setupStore.isManualProfileRunning,
  isManualProfilePaused: store.setupStore.isManualProfilePaused,
  CustomOperation: store.setupStore.CustomOperation,
}))
class StatusService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: STATUS_SEQUENCE_DESINGER.IDLE,
    };
  }

  componentWillUnmount() {
    clearInterval(this._statusServicePooling);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {CustomOperation, isManualProfileRunning, isManualProfilePaused} = nextProps;
    const {status} = prevState;

    /**
     * Status changed handler
     */
    if (CustomOperation.Status !== status) {
      switch (CustomOperation.Status) {
        case STATUS_SEQUENCE_DESINGER.DEPRESSURIZING:
          nextProps.depressurizeCallBack();
          break;

        case STATUS_SEQUENCE_DESINGER.PAUSED:
          batch(() => {
            if (isManualProfileRunning) nextProps.dispatch(setupActions.updateIsManualProfileRunning(true));
            if (!isManualProfilePaused) nextProps.dispatch(setupActions.updateIsManualProfilePaused(true));
          });
          break;

        case STATUS_SEQUENCE_DESINGER.IDLE:
          batch(() => {
            if (isManualProfileRunning) {
              nextProps.dispatch(setupActions.updateIsManualProfileRunning(false));
              nextProps.finishCallBack({message: CustomOperation.Message});
            }
            if (isManualProfilePaused) nextProps.dispatch(setupActions.updateIsManualProfilePaused(false));
          });
          break;

        default:
          batch(() => {
            if (!isManualProfileRunning) nextProps.dispatch(setupActions.updateIsManualProfileRunning(true));
            if (isManualProfilePaused) nextProps.dispatch(setupActions.updateIsManualProfilePaused(false));
          });
          break;
      }
      return {...prevState, status: CustomOperation.Status};
    }

    // No state update necessary
    return {...prevState};
  }

  render() {
    return null;
  }
}
// TODO: need to define the props derived structure
StatusService.propTypes = {
  depressurizeCallBack: PropTypes.func,
  finishCallBack: PropTypes.func,
};
StatusService.defaultProps = {
  depressurizeCallBack: () => consoleDebug('Sample output'),
  /**
   * @param {Object} response
   * @param {String} response.message
   */
  finishCallBack: (response) => consoleDebug('Sample output', response),
};
export default StatusService;
